import { render, staticRenderFns } from "./mailTemplate.vue?vue&type=template&id=0f152ba4&"
import script from "./mailTemplate.vue?vue&type=script&lang=js&"
export * from "./mailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports